module.exports = __webpack_public_path__ + "img/brown-wooden-center-table-584399.18cae9e4.jpg";